module.exports = __webpack_public_path__ + "static/media/survey-completed.2d36dba8.svg";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/survey-completed.svg
// module id = 360
// module chunks = 0